import React from "react";

import "../../../assets/stlyes/CustomConfirmModal.scss";

import WarningIcon from "../../../assets/images/WarningToDelete.svg";
import { Common, WARNING } from "../../../helper";

const CustomConfirmModal = (props) => {
  const { isOpen, onClose, onConfirm, subjectName, whichTodelete } = props;

  if (!isOpen) return null;

  return (
    <div className="modal-confirm-delete-overlay">
      <div className="modal-confirm-delete-content">
        <img src={WarningIcon} alt="warning" />
        <p className="modal-confirm-delete-title">{(whichTodelete.additionalSubject || whichTodelete.mainSubject) ? `${WARNING.REMOVE_SUBJECT} ${subjectName} ?` : whichTodelete.reset ? WARNING.RESET_REPORT : whichTodelete.generalComment ? WARNING.REMOVE_GENERAL_COMMENT : ""}</p>
        <div className="modal-confirm-delete-buttons">
          <button onClick={onConfirm}>{Common.Yes_}</button>
          <button onClick={onClose}>{Common.No}</button>
        </div>
      </div>
    </div>
  );
};

export { CustomConfirmModal };